<template>
    <div>
        <div v-show="show" class="w-full flex justify-center">
            <div
                id="delivery-note"
                ref="deliveryNoteTemplate"
                class="w-ticket bg-white text-black py-4 flex flex-wrap"
            >
                <div class="w-full">
                    <span class="mt-2 ml-2 text-lg font-bold">
                        {{ deliveryNote.city }}
                    </span>
                </div>

                <div class="w-full flex flex-col">
                    <span class="mt-2 ml-2 h5">
                        {{
                            deliveryNote.receiverName
                                ? deliveryNote.receiverName
                                : `${deliveryNote.firstName} ${deliveryNote.lastName}`
                        }}
                    </span>
                </div>

                <div class="w-full flex flex-col">
                    <span class="mt-2 ml-2">
                        {{ deliveryNote.address }} |
                        {{ deliveryNote.neighborhood }} |
                        {{ deliveryNote.addressComplement }}
                    </span>
                </div>

                <div class="w-full flex flex-col">
                    <span class="mt-2 ml-2">
                        {{
                            deliveryNote.receiverPhone
                                ? deliveryNote.receiverPhone
                                : deliveryNote.phone
                        }}
                    </span>
                </div>

                <div class="w-full flex flex-col">
                    <span class="mt-2 ml-2">
                        Ref. {{ deliveryNote.uuid }}
                    </span>
                </div>

                <div
                    class="w-full mt-2 flex flex-col justify-center items-center"
                >
                    <barcode-viewer :input="deliveryNote.uuid" />
                </div>

                <div
                    class="w-full mt-1 flex flex-col justify-center items-center"
                >
                    <img
                        src="/img/logos/complete_logo.png"
                        width="60"
                        alt="Logo"
                    />
                </div>
            </div>
        </div>

        <div v-if="showPrint" class="mt-4 w-full flex justify-center gap-2">
            <pdf-download-button @click="generatePdf" />
            <slot name="buttons"></slot>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import { downLoadPDF, elementToPDF, openPDF } from "@/common/lib/pdf";

import BarcodeViewer from "@/components/utils/BarcodeViewer.vue";
import PdfDownloadButton from "@/components/utils/PdfDownloadButton.vue";

export default {
    name: "DeliveryNotePrinter",
    components: { BarcodeViewer, PdfDownloadButton },
    props: {
        show: {
            default: () => false,
            required: false,
            type: Boolean
        },
        deliveryNote: {
            default: () => ({
                uuid: "12123131",
                cityCode: "",
                city: "Bogota"
            }),
            required: false,
            type: Object
        },
        showPrint: {
            default: () => false,
            required: false,
            type: Boolean
        }
    },
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    methods: {
        async generatePdf() {
            try {
                const pdf = await this.$loading.wrap(() =>
                    elementToPDF(this.$refs.deliveryNoteTemplate)
                );
                const filename = `guia_entrega_${this.deliveryNote.uuid}`;
                if (this.$isPhone) {
                    downLoadPDF(pdf, filename);
                } else {
                    openPDF(pdf, filename);
                }
            } catch (error) {
                this.showGenerationError(error);
            }
        },
        showGenerationError(error) {
            console.error("Error generando el PDF", error);
            this.$swal.fire({
                icon: "error",
                title: "No pudimos generar el PDF",
                text:
                    error?.message ||
                    (typeof error === "string" && error) ||
                    "Intenta de nuevo en unos segundos.",
                background: this.backgroundColor
            });
        }
    }
};
</script>
